var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application",domProps:{"innerHTML":_vm._s(_vm.getTemplate())}})
}
var staticRenderFns = []

export { render, staticRenderFns }